import {combineReducers, createStore} from 'redux';
import { accountsReducer } from './AccountsReducer';
import authReducers from './AuthReducers';
import { dashboardReducer } from './dashBoardReducers';
import { ProductsReducer } from './productPageReducers';

const reducers=combineReducers({
    auth:authReducers,
    dashboard:dashboardReducer,
    products:ProductsReducer,
    accountsData:accountsReducer
})
 const store = createStore(reducers);



export default store